/* Vitalys probio upsell — selector de packs en el cart drawer.
   El producto 'vitalys-probiotiques' tiene pack-variantes (1/2/3 pots) con
   precio unitario remisado; se añade la variante elegida con quantity = pots.
   El estado (pill activa, botón, "Retirer") lo re-renderiza el servidor vía
   sections; aquí solo: selección visual + add/change/remove. */
(function () {
  'use strict';

  var busy = false;

  function root() {
    return document.querySelector('[data-vitalys-probio]');
  }

  function sectionsToRequest() {
    var list = ['cart-drawer', 'cart-icon-bubble'];
    var main = document.getElementById('main-cart-items');
    if (main && main.dataset.id) list.push(main.dataset.id);
    return list;
  }

  function renderSections(sections) {
    if (!sections) return;
    var drawerBox = document.getElementById('CartDrawer');
    if (drawerBox && sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('#CartDrawer');
      if (fresh) {
        drawerBox.innerHTML = fresh.innerHTML;
        var wrapper = document.querySelector('cart-drawer');
        var overlay = document.getElementById('CartDrawer-Overlay');
        if (wrapper && overlay) overlay.addEventListener('click', wrapper.close.bind(wrapper));
        if (wrapper) wrapper.classList.toggle('is-empty', !!doc.querySelector('.drawer__inner-empty'));
      }
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var doc2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var el2 = doc2.querySelector('.shopify-section') || doc2.body;
      bubble.innerHTML = el2.innerHTML;
    }
    var main = document.getElementById('main-cart-items');
    if (main && main.dataset.id && sections[main.dataset.id]) {
      var doc3 = new DOMParser().parseFromString(sections[main.dataset.id], 'text/html');
      var freshContents = doc3.querySelector('.js-contents');
      var target = main.querySelector('.js-contents');
      if (freshContents && target) target.innerHTML = freshContents.innerHTML;
    }
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function selectedPill(box) {
    return box.querySelector('[data-vpu-pill].is-active');
  }

  function refreshButton(box) {
    var btn = box.querySelector('[data-vpu-add]');
    var pill = selectedPill(box);
    if (!btn || !pill) return;
    var current = box.getAttribute('data-current-variant') || '0';
    var chosen = pill.getAttribute('data-variant-id');
    if (current !== '0' && current === chosen) {
      btn.textContent = btn.getAttribute('data-label-added').replace('&#10003;', '✓');
      btn.disabled = true;
    } else if (current !== '0') {
      btn.textContent = btn.getAttribute('data-label-change') + ' — ' + pill.getAttribute('data-total');
      btn.disabled = false;
    } else {
      btn.textContent = btn.getAttribute('data-label-add') + ' — ' + pill.getAttribute('data-total');
      btn.disabled = false;
    }
  }

  function apply(box) {
    if (busy) return;
    var pill = selectedPill(box);
    if (!pill) return;
    var chosen = Number(pill.getAttribute('data-variant-id'));
    var qty = Number(pill.getAttribute('data-qty')) || 1;
    var current = Number(box.getAttribute('data-current-variant') || '0');
    if (current && current === chosen) return;
    busy = true;
    var btn = box.querySelector('[data-vpu-add]');
    if (btn) btn.disabled = true;

    var step = Promise.resolve(null);
    if (current) {
      var updates = {};
      updates[current] = 0;
      step = post(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/update.js', { updates: updates });
    }
    step
      .then(function () {
        return post(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', { id: chosen, quantity: qty, sections: sectionsToRequest() });
      })
      .then(function (data) {
        if (data && data.sections) renderSections(data.sections);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function (err) {
        if (window.console) console.warn('[vitalys-probio-upsell]', err);
      })
      .finally(function () { busy = false; });
  }

  function removeAll(box) {
    if (busy) return;
    busy = true;
    var ids = (box.getAttribute('data-variant-ids') || '').split(',').filter(Boolean);
    var updates = {};
    ids.forEach(function (id) { updates[id] = 0; });
    post(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/update.js', { updates: updates, sections: sectionsToRequest() })
      .then(function (data) {
        if (data && data.sections) renderSections(data.sections);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function (err) {
        if (window.console) console.warn('[vitalys-probio-upsell] remove', err);
      })
      .finally(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-vpu-pill]');
    if (pill) {
      e.preventDefault();
      var box = pill.closest('[data-vitalys-probio]');
      box.querySelectorAll('[data-vpu-pill]').forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      refreshButton(box);
      return;
    }
    var add = e.target.closest('[data-vpu-add]');
    if (add) {
      e.preventDefault();
      apply(add.closest('[data-vitalys-probio]'));
      return;
    }
    var rem = e.target.closest('[data-vpu-remove]');
    if (rem) {
      e.preventDefault();
      removeAll(rem.closest('[data-vitalys-probio]'));
    }
  });
})();
